import { quillEditor as Editor, Quill } from 'vue-quill-editor/src'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import './editor.scss'

import {container, ImageExtend, QuillWatch} from './image'

Quill.register('modules/ImageExtend', ImageExtend)

Editor.name = 'editor'
Editor.props.options.default = () => {
  return {
    modules: {
      ImageExtend: {
        loading: true,
        name: 'file',
        action: window.__CONFIG__.api + '/admin/v1/file/upload',
        headers:(xhr)=>{
          xhr.withCredentials = true
        },
        response: (res) => {
          return res.data.path
        }
      },
      toolbar: {
        container: container,
        handlers: {
          'image': function () {
            QuillWatch.emit(this.quill.id)
          }
        }
      }
    }
  }
}
export default Editor
